import React from "react";
import { Box, BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * SidebarNav (desktop) and MobileBottomNav (mobile)
 * Props:
 *  - icons: array of image paths
 *  - activeNav: number
 *  - setActiveNav: fn
 *  - routes: array of route paths corresponding to icons
 *  - bottomNavHeight: number (for mobile)
 */


export const SidebarNav = ({ icons, activeNav, setActiveNav, routes }) => {
  const navigate = useNavigate();

  const navigateLink = (route) => {
    if (route.startsWith("http")) {
      window.location.href = route; // navigate to external link
    } else {
      navigate(route); // navigate internally
    }
  };

  return (
    <Box
      sx={{
        width: 80,
        borderRight: "1px solid #eee",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
      }}
    >
      {icons.map((path, idx) => (
        <Box
          key={idx}
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => {
            setActiveNav(idx);
            navigateLink(routes[idx]);
          }}
        >
          <Box component="img" src={path} alt={`icon-${idx}`} sx={{ width: 40, height: 40, background:"transparent" }} />
          {activeNav === idx && (
            <Box
              sx={{
                position: "absolute",
                right: -20,
                width: 3,
                height: 40,
                borderRadius: 3,
                bgcolor: "#ff007f",
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

export const MobileBottomNav = ({ icons, activeNav, setActiveNav, routes, bottomNavHeight }) => {
  const navigate = useNavigate();
  const navigateLink = (route) => {
    if (route.startsWith("http")) {
      window.location.href = route; // navigate to external link
    } else {
      navigate(route); // navigate internally
    }
  };

  return (
    <BottomNavigation
      value={activeNav}
      onChange={(e, v) => {
        setActiveNav(v);
        navigateLink(routes[v]);
      }}
      sx={{
        width: "100%",
        borderTop: "1px solid #eee",
        height: bottomNavHeight,
        "& .MuiBottomNavigationAction-root.Mui-selected::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: 53,
          height: 3,
          borderRadius: 3,
          bgcolor: "#ff007f",
        },
      }}
      showLabels
    >
      {icons.map((path, idx) => (
        <BottomNavigationAction
          key={idx}
          icon={<Box component="img" src={path} alt={`icon-${idx}`} sx={{ width: idx === 1 ? 40 : 30, height: idx===1 ? 36 : 30, background:"transparent" }} />}
        />
      ))}
    </BottomNavigation>
  );
};